import Payments from "./Tabs/Payments/Payments"
import Schedule from "./Tabs/Schedule/Schedule"
import AffiliatePayments from "./Tabs/AffiliatesPayments/Payments"

export const getTabs = ({ activeTab, userRole, isSupervisor }) => {
  const tabs = {
    schedule: <Schedule userRole={userRole}/>,
    payments: <Payments userRole={userRole}/>
  }

  const affiliateTabs = {
    payments: <AffiliatePayments userRole={userRole}/>
  }

  switch (userRole) {
    case 'customer':
      return tabs[activeTab]
    case 'affiliate':
      return affiliateTabs[activeTab]
    case 'affiliateGroupsAdmin':
      return affiliateTabs[activeTab]
    case 'user':
      if (isSupervisor) {
        return tabs[activeTab]
      }
      break
    default:
      return <div>Permission Denied</div>
  }
}